/* eslint-disable better-mutation/no-mutation */

import { isServer } from 'tradera/utils/nextjs';

if (isServer) {
    // Do not remove this without also removing the disable of eslint better-mutation/no-mutation at top of file.
    throw new Error(
        'This implementation may not compatible with SSR where global properties are shared between server instances'
    );
}

(function ($) {
    if (!$) {
        return;
    }

    const jqueryTrigger = $.event.trigger;
    // trigger signature: function (event, data, elem, onlyHandlers)
    $.event.trigger = function (event, data, elem, onlyHandlers) {
        try {
            // Dispatch regular event, prefixed with 'jquery:'
            const eventPrefix = 'jquery:';
            const prefixedEventName = eventPrefix + event;
            const jsEvent = data
                ? new CustomEvent(prefixedEventName, { detail: data })
                : new CustomEvent(prefixedEventName);
            const elem2dispatchEvent = elem ? elem : window;
            elem2dispatchEvent.dispatchEvent(jsEvent);
        } catch (error) {
            return;
        }

        // Dispatch jquery event
        jqueryTrigger(event, data, elem, onlyHandlers);
    };
})(window.jQuery);
